import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
	standalone: false,
	selector: 'app-payment-timeout-modal',
	templateUrl: './payment-timeout-modal.component.html',
	styleUrls: ['./payment-timeout-modal.component.scss'],
})
export class PaymentTimeoutModalComponent {
	private modalCtrl = inject(ModalController);

	static async show(modalCtrl: ModalController): Promise<void> {
		const modal = await modalCtrl.create({
			component: PaymentTimeoutModalComponent,
			showBackdrop: true,
			backdropDismiss: true,
			cssClass: 'payment-timeout-sheet',
		});

		await modal.present();
		await modal.onWillDismiss();
	}

	async close() {
		await this.modalCtrl.dismiss();
	}
}
